var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseStringIdDataDto } from '../../../classes/common';
export class ReservationWithHistoryCountDto extends BaseStringIdDataDto {
    constructor({ id, createdAt, updatedAt, deletedAt, state, customerName1, vendorName, vehicleModelName, pickUpAt, dropOffAt, isPaymentChangedCount, isDateChangedCount, isFeeChangedCount, }) {
        super({ id, createdAt, updatedAt, deletedAt });
        this.state = state;
        this.customerName1 = customerName1;
        this.vendorName = vendorName;
        this.vehicleModelName = vehicleModelName;
        this.pickUpAt = pickUpAt;
        this.dropOffAt = dropOffAt;
        this.isPaymentChangedCount = isPaymentChangedCount;
        this.isDateChangedCount = isDateChangedCount;
        this.isFeeChangedCount = isFeeChangedCount;
    }
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], ReservationWithHistoryCountDto.prototype, "pickUpAt", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], ReservationWithHistoryCountDto.prototype, "dropOffAt", void 0);
